import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function PushNotification({
  open,
  setOpen,
  onSubmit,
  loading,
  newsStatus,
  title = "Enable push notification for this article?",
  content = "Would you like to send a notification to users when this news is published?",
}) {
  return (
    <ModalComp
      title={title}
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setOpen(false)}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={newsStatus === 4 ? loading : false}
          handleSecondaryBtn={() => {
            onSubmit();
            setOpen(false);
          }}
          secondaryBtnText="Publish"
        />
      }
      open={open}
      setOpen={setOpen}
    >
      {content}
    </ModalComp>
  );
}

export default PushNotification;
